import React from 'react';
import { ArrowRight, Smartphone, Code, Database, Shield, Zap, Users, TrendingUp, CheckCircle } from 'lucide-react';
import Header from "./header";
import Footer from './footer';
const CombinedAppServices = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
     <Header/>

      {/* Hero Section - Application Development */}
      <section className="bg-gradient-to-br from-blue-50 to-blue-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Application
                <span className="text-blue-600 block">Development</span>
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                In today's rapidly evolving digital landscape, 
                enterprises are constantly challenged to adapt and 
                innovate. Often, legacy systems prove to be 
                insufficient. To thrive, businesses need agile, 
                customized application development that aligns with 
                their specific requirements and strategic goals.
              </p>
           
            </div>
            <div className="relative">
                <div className="bg-white rounded-2xl shadow-xl p-8">
                    <div className="flex space-x-4 mb-6">
                    <div className="bg-blue-100 p-4 rounded-xl">
                        <Smartphone className="w-8 h-8 text-blue-600" />
                    </div>
                    <div className="bg-green-100 p-4 rounded-xl">
                        <Code className="w-8 h-8 text-green-600" />
                    </div>
                    <div className="bg-purple-100 p-4 rounded-xl">
                        <Database className="w-8 h-8 text-purple-600" />
                    </div>
                    </div>
                    <h3 className="text-xl font-semibold mb-4">Custom Solutions</h3>
                    <p className="text-gray-600">Building innovative applications tailored to your business needs</p>
                </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Application Development */}
 <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="./mobile-app1.jpg" 
                alt="Mobile-First Development" 
                className="w-full h-auto rounded-2xl shadow-lg object-cover"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                About Our
                <span className="text-blue-600 block">Application Development</span>
                <span className="text-gray-900">Services</span>
              </h2>
              <p className="text-gray-600 mb-6">
                Technology is changing the way businesses are done 
                earlier and this also means that every way of conducting business 
                is also changing. With a lot of emerging technologies, 
                the ever-changing cloud platforms, the explosion of 
                digital platforms, mobile applications, and application 
                upgrades, enterprises are looking for customized 
                application development services to support their 
                business needs.
              </p>
              <p className="text-gray-600 mb-8">
                Tigerworld Technologies helps enterprises in 
                building custom applications swiftly without 
                compromising on quality. Our experts having deep expertise in customizable 
                solutions, we help our clients in their transformation 
                journey by leveraging our proven and time tested 
                deployment tactics and industry best practices.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">Agile Development</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">Scalable Architecture</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">Cloud Integration</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
                  <span className="text-gray-700">24/7 Support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hero Section - Application Maintenance */}
      <section className="bg-gradient-to-br from-cyan-50 to-blue-100 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Application
                <span className="text-cyan-600 block">Maintenance</span>
              </h1>
              <p className="text-lg text-gray-600 mb-8">
                For enterprises seeking tangible results and a strong 
                return on their IT investment, Tigerworld Technologies 
                offers a focused and value-driven approach to 
                application development. By combining deep industry 
                expertise with innovative thinking, delivering superior 
                end-to-end AMS services that drive real business value and 
                support your transformation journey.
              </p>
            
            </div>
            <div className="relative">
              <img 
                src="./maintaince.jpeg" 
                alt="Application Maintenance Services" 
                className="w-full h-auto rounded-2xl shadow-xl object-cover"
              />
            </div>
          </div>
        </div>
      </section>

    
 

      {/* 3E Model Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Anvitech <span className="text-blue-600">3E Model</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              As a IT Software Consulting Services specialist - Anvitech Application Maintenance 
              Support (AMS) services are delivered by a proven 3E Managed Services Model – Efficiency, 
              Effectiveness, and Experience.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Zap className="w-8 h-8 text-blue-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Efficiency</h3>
              <p className="text-gray-600 mb-4">
                We focus on reduction in operational costs by continuously improving, 
                re-engineering and accelerating operational practices so as to lay 
                foundation for leveraging lean and automation strategies and 
                methodologies to achieve improved incident reduction and 
                proper root cause analysis so as to improve efficiency.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <TrendingUp className="w-8 h-8 text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Effectiveness</h3>
              <p className="text-gray-600 mb-4">
                We adopt the "OPTIMIZATION" approach to deliver Business Process 
                Improvements by orchestrating business and processes across end-to-end 
                business workflows through predictive monitoring of business 
                performance that helps to prevent business disruptions 
                and root cause analysis on the top-line and bottom-line.
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                <Users className="w-8 h-8 text-purple-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Experience</h3>
              <p className="text-gray-600 mb-4">
                Tigerworld Application Support teams are strategically focused on 
                delivering solutions by delivering personalized customer experience. This 
                is always driven by data and insights which are tailored 
                to solve specific business challenges. The focus is on 
                continuously engaging with end users and by providing 
                business value to ensure potential service 
                improvements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tigerworld Technologies Difference */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <span className="text-blue-600">Anvitech Technologies</span> Difference
            </h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto">
              Innovation is at the heart of the Tigerworld Technologies difference. Their significant 
              investment in leading-edge development services clients benefit from proven 
              methodologies and pre-built components, leading to faster deployments and tangible 
              results.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Code className="w-10 h-10 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Very Comprehensive Application Development Services (ADM)</h3>
              <p className="text-gray-600 text-sm">
                We help our clients accelerate a full spectrum of their application development needs, 
                development services which reduce risk and enhance scalability, robust, secure, and easily 
                maintainable.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-green-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Database className="w-10 h-10 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Industry Domain Knowledge</h3>
              <p className="text-gray-600 text-sm">
                Tigerworld brings a lot of industry expertise to the table. Our transformational experts are 
                skilled in latest services and deployment techniques which reduce time and cost while 
                offering predictability and comfort.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-purple-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="w-10 h-10 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Investment Banking Solution Accelerators</h3>
              <p className="text-gray-600 text-sm">
                Tigerworld's innovative approach has been in the space of application development with 
                solutions and this has enabled in helping our clients to budget timelines and proven 
                deployment techniques.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-cyan-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <TrendingUp className="w-10 h-10 text-cyan-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Major Focus on Results with Return on Investment (ROI)</h3>
              <p className="text-gray-600 text-sm">
                Tigerworld's major focus is on delivering application development services and solutions that 
                drive and we give value to our clients to provide end-to-end AMS services to support 
                application development.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default CombinedAppServices;